import moment from 'moment';

/**
 * Is the given moment either
 *   1. some time today or
 *   2. some time in the past?
 *
 * @param m {Moment} moment to test.
 * @return {Boolean}
 */
export default function isTodayOrInThePast(m) {
  const now = moment();
  // No need for isSameOrAfter -- can't be same, since same would have the same day.
  return now.isSame(m, 'day') || now.isAfter(m);
}
